import ScreenWrapper from "@/components/ScreenWrapper"
import { ProfileSidebar } from "@/pages/profiel/ProfileSidebar"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { LayoutWithSidebar, SidebarWrapper } from "toptaal-shared"

export const Route = createFileRoute("/profiel")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        sidebar={
          <SidebarWrapper>
            <ProfileSidebar />
          </SidebarWrapper>
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
